import champions from '../../../public/assets/lol/champions-data.json';

// We create our own champions map (id => Champion) using the Riot JSON.
// http://ddragon.leagueoflegends.com/cdn/11.16.1/data/en_US/champion.json
// Note: Notice that for us the property 'id' is call 'key' on Riot JSON.

export const championsMap = {}; // id => Champion

export function setLolChampionsMap() {
  for (const champName in champions.data) {
    if (Object.prototype.hasOwnProperty.call(champions.data, champName)) {
      const champ = champions.data[champName];

      championsMap[champ.key] = {
        name: champ.name,
        nameId: champ.id,
      };
    }
  }
}
